import React from "react";
import UiSelect from "../../../_uiMocks/_uiComponents/UiSelect";
import UiDateRangePicker from "../../../_uiMocks/_uiComponents/UiDateRangePicker";
import DehazeIcon from "@mui/icons-material/Dehaze";
import {
     Chart,
     ChartTitle,
     ChartLegend,
     ChartArea,
     ChartTooltip,
     ChartSeries,
     ChartSeriesItem,
     ChartSeriesLabels,
} from "@progress/kendo-react-charts";
import UiSlider from "../../../_uiComponents/common/UiSlider";
import DoughnutQ4Oilmasters from "./DoughnutQ4Oilmasters";
import DoughnutQ4WearTear from "./DoughnutQ4WearTear";
import CarouselAbuDhabi from "./CarouselAbuDhabi";
export default function CampaignDonutsGraph(props) {
     const labelContent = (e) => `${e.value}`;
     

     return (
          <>   
               <div className="sba-drag-handle">
                    <DehazeIcon />
               </div>
               <UiSlider slidesToShow={2} infinite={false}>
                    <DoughnutQ4Oilmasters
                         applicationId={props.applicationId}
                         jobRolesOptions={props.jobRolesOptions}
                         getQ4OilMasterSummary={props.getQ4OilMasterSummary}
                    />
                    <DoughnutQ4WearTear
                         applicationId={props.applicationId}
                         jobRolesOptions={props.jobRolesOptions}
                         getWearTearSummary={props.getWearTearSummary}
                    />
                    <CarouselAbuDhabi
                         // applicationId={props.applicationId}
                         // jobRolesOptions={props.jobRolesOptions}
                         // getAbuDhabiSummary={props.getAbuDhabiSummary}
                    />
               </UiSlider>
          </>
     );
}
